'use client'

import { type FC } from 'react'

import { type OpenableControls } from '../../generic-hooks'
import { type PersonalAdviceProduct } from '../PersonalAdviceProduct'

import { PersonalAdviceDialogWithoutAccordion } from './PersonalAdviceDialogWithoutAccordion'
import { PersonalAdviceDialogWithoutAccordionProvider } from './PersonalAdviceDialogWithoutAccordionContext'

export const PersonalAdviceDialog: FC<{
  dialogControls: OpenableControls
  product?: PersonalAdviceProduct
}> = ({ dialogControls, product }) => {
  return (
    <PersonalAdviceDialogWithoutAccordionProvider
      dialogControls={dialogControls}
      product={product}
    >
      <PersonalAdviceDialogWithoutAccordion />
    </PersonalAdviceDialogWithoutAccordionProvider>
  )
}
